import { applyHousekeepingWrite as e } from "./invalidateHousekeeping.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { housekeepingApi as r } from "@maat/api-main";
//#region src/housekeeping/useAssignHousekeepingRoomsMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.assignRooms(i, e),
		onSuccess: ({ rooms: t }) => e(a, i, t)
	});
};
//#endregion
export { i as useAssignHousekeepingRoomsMutation };
